export default "__VITE_ASSET__4df1873a__"